// ユーザー削除
$(function () {
    $('.js-user-destroy').on('click', function(e) {
        e.preventDefault();
        const action = $(this).data('action');
        const confirmMessage = $(this).data('confirm');

        // 再選択を行う場合に備えて該当項目の選択状態を解除
        if (confirmMessage && !confirm(confirmMessage)) {
            return false;
        }

        let form = document.createElement('form');
        form.action = action;
        form.method = 'post';

        let Token = document.createElement("input");
        Token.setAttribute("type","hidden");
        Token.setAttribute("name","_token");
        Token.setAttribute("value",$('meta[name="csrf-token"]').attr('content'));
        form.appendChild(Token);

        document.body.appendChild(form);
        form.submit();
    });
})
